import { useMemo } from 'react';
import { Box } from '@mui/material';

import { ParticipantTile } from './ParticipantTile';

interface GridViewProps {
  participantIds: string[];
  activeSpeakerId: string | null;
  localSessionId: string;
  fillHeight?: boolean;
}

function getColumnCount(participantCount: number): number {
  if (participantCount <= 4) return 2;
  return 3; // 5-9
}

export function GridView({
  participantIds,
  activeSpeakerId,
  localSessionId,
  fillHeight = false,
}: GridViewProps) {
  const columns = useMemo(() => getColumnCount(participantIds.length), [participantIds.length]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        ...(fillHeight ? { flex: 1, minHeight: 0 } : {}),
        borderRadius: '8px',
        overflow: 'hidden',
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: 1.5,
        alignContent: 'center',
      }}
    >
      {participantIds.map(id => (
        <ParticipantTile
          key={id}
          sessionId={id}
          variant={fillHeight ? 'gridFill' : 'grid'}
          isLocal={id === localSessionId}
          isActiveSpeaker={id === activeSpeakerId}
        />
      ))}
    </Box>
  );
}
